export default __webpack_public_path__ + "static/media/central.c6e7e3fd.jpg";